var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76588 6.98274C4.86239 5.93961 5.69543 5.11779 6.73865 5.02788C11.0269 4.65829 14.0044 4.65722 18.2583 5.0256C19.3066 5.11639 20.1407 5.94647 20.2335 6.99512C20.6079 11.2276 20.5734 14.2161 20.2203 18.484C20.1326 19.5444 19.2928 20.3889 18.2331 20.4787C13.9667 20.8405 10.9928 20.8397 6.78078 20.4805C5.71856 20.3899 4.87877 19.5409 4.792 18.4778C4.44716 14.253 4.37042 11.2572 4.76588 6.98274Z",
    stroke: "#5C5F62",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.25V6.75",
    stroke: "#5C5F62",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.25V6.75",
    stroke: "#5C5F62",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.75H20",
    stroke: "#5C5F62",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.25H8.51",
    stroke: "#5C5F62",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.75H8.51",
    stroke: "#5C5F62",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5098 13.25H12.5198",
    stroke: "#5C5F62",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5098 16.75H12.5198",
    stroke: "#5C5F62",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.52 13.25H16.53",
    stroke: "#5C5F62",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.52 16.75H16.53",
    stroke: "#5C5F62",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.2f250827aa4c476b910dbeef55a33725.svg";
export { ForwardRef as ReactComponent };